// Skala planu (zgłoszenie Jacka 13.10: „przesunięcie o 1 cm na planie to np. 50 cm w rzeczywistości”).
// Punkty PDF: 72 na cal, więc 1 m w rzeczywistości przy skali 1:M to 72 / 0,0254 / M punktów planu.
export const PT_NA_M_1_1 = 72 / 0.0254;
const TYPOWE = [10, 20, 25, 50, 75, 100, 125, 200, 250, 500, 1000];

/** Punkty PDF na metr rzeczywisty: z kalibracji piętra, a bez niej ze skali planu. null = nieznana. */
export function ptNaM(pietro) {
  if (pietro?.kalibracja?.ptNaM) return +pietro.kalibracja.ptNaM;
  return pietro?.skala ? PT_NA_M_1_1 / pietro.skala : null;
}

/** Mianownik skali (1:50 → 50): z kalibracji zaokrąglony do typowej skali, inaczej zapisana skala planu. */
export function skala(pietro) {
  if (pietro?.kalibracja?.ptNaM) { const m = PT_NA_M_1_1 / pietro.kalibracja.ptNaM; const t = TYPOWE.find((x) => Math.abs(x - m) / x < 0.03); return t || Math.round(m); }
  return pietro?.skala || null;
}

/** Skala z tekstu planu: „M 1:50”, „Maßstab 1:100”, „1 : 50”. Zwraca najczęstszą typową skalę albo null. */
export function skalaZTekstu(slowa) {
  const t = slowa.map((s) => s.t).join(' ');
  const ile = {};
  for (const m of t.matchAll(/(?:^|[^\d.,:])1\s?:\s?(\d{2,4})(?![\d.,:])/g)) { const v = +m[1]; if (TYPOWE.includes(v)) ile[v] = (ile[v] || 0) + 1; }
  const naj = Object.entries(ile).sort((a, b) => b[1] - a[1])[0];
  return naj ? +naj[0] : null;
}

/** Ile to na planie (papier w skali): cm rzeczywiste → cm na wydruku planu. */
export const cmNaPlanie = (cmRzecz, M) => (M ? cmRzecz / M : null);
